import React, { useState, useEffect } from "react";
import { Slide } from "react-slideshow-image";
import Img from '../components/image';
import 'react-slideshow-image/dist/styles.css';

import slider from '../locales/slider';




const Slider = () => {

  const slides = [
    {
      img: slider.slide10.img,
      link: slider.slide10.link,
      text: slider.slide10.text,
      alt: slider.slide10.alt,

    },
    {
      img: slider.slide11.img,
      link: slider.slide11.link,
      text: slider.slide11.text,
      alt: slider.slide11.alt

    },
    {
      img: slider.slide12.img,
      link: slider.slide12.link,
      text: slider.slide12.text,
      alt: slider.slide12.alt

    },
    {
      img: slider.slide13.img,
      link: slider.slide13.link,
      text: slider.slide13.text,
      alt: slider.slide13.alt

    },
    {
      img: slider.slide1.img,
      link: slider.slide1.link,
      text: slider.slide1.text,
      alt: slider.slide1.alt,

    },
    {
      img: slider.slide2.img,
      link: slider.slide2.link,
      text: slider.slide2.text,
      alt: slider.slide2.alt

    },
    {
      img: slider.slide3.img,
      link: slider.slide3.link,
      text: slider.slide3.text,
      alt: slider.slide3.alt

    },
    {
      img: slider.slide4.img,
      link: slider.slide4.link,
      text: slider.slide4.text,
      alt: slider.slide4.alt

    },
    {
      img: slider.slide5.img,
      link: slider.slide5.link,
      text: slider.slide5.text,
      alt: slider.slide5.alt

    },
    {
      img: slider.slide6.img,
      link: slider.slide6.link,
      text: slider.slide6.text,
      alt: slider.slide6.alt

    },
    {
      img: slider.slide7.img,
      link: slider.slide7.link,
      text: slider.slide7.text,
      alt: slider.slide7.alt

    },
    {
      img: slider.slide8.img,
      link: slider.slide8.link,
      text: slider.slide8.text,
      alt: slider.slide8.alt

    },
    {
      img: slider.slide9.img,
      link: slider.slide9.link,
      text: slider.slide9.text,
      alt: slider.slide9.alt

    },
   

  ]

  //handle resizing
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const style = {
    textAlign: 'center',
    color: 'black',
    padding: '20px 0',
    fontSize: '30px',
    margin: '10px'
  };


  const properties = {
    transitionDuration: 500,
    duration: 50,
    autoplay: false,
    indicators: true,

    // 600  and 900 are placeholder breakpoints, to change
    canSwipe: windowSize.width > 900 ? false : windowSize.width > 600 ? true : true,
    slidesToShow: windowSize.width > 900 ? 3 : windowSize.width > 600 ? 2 : 1,
    slidesToScroll: windowSize.width > 900 ? 3 : windowSize.width > 600 ? 2 : 1,
  };

  return (
    <div className="reflecting">
      <div className="large container medium-padding-vertical">
        <h2 className="purple">{slider.title}</h2>
        <p>{slider.content}</p>

        <Slide {...properties}>
          {slides.map((slide, index) => (
            <div key={index} style={style}><a href={slide.link} target="_blank" rel="noreferrer">
              <div className="sliderImgContainer">
                <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={slide.img} alt={slide.alt} />
              </div>
              <p>{slide.text}</p>
              </a>
            </div>
          ))}
        </Slide>
      </div>


    </div>
  );
};

export default Slider;